function showToastNotification(message: string, type: 'success' | 'error') {
  if (typeof document === 'undefined') return;

  let container = document.getElementById('ael-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'ael-toast-container';
    container.className = 'fixed bottom-5 right-5 z-50 flex flex-col gap-2 pointer-events-none';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = `px-4 py-3 rounded-xl shadow-lg text-sm font-medium transition-all duration-300 pointer-events-auto transform translate-y-2 opacity-0 flex items-center gap-2 ${
    type === 'success'
      ? 'bg-emerald-900 text-emerald-100 border border-emerald-700'
      : 'bg-red-900 text-red-100 border border-red-700'
  }`;
  toast.innerText = message;
  container.appendChild(toast);

  // Animate in
  requestAnimationFrame(() => {
    toast.classList.remove('translate-y-2', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
  });

  // Animate out and remove
  setTimeout(() => {
    toast.classList.remove('translate-y-0', 'opacity-100');
    toast.classList.add('translate-y-2', 'opacity-0');
    setTimeout(() => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 300);
  }, 4000);
}

export const toast = {
  success: (msg: string) => showToastNotification(msg, 'success'),
  error: (msg: string) => showToastNotification(msg, 'error'),
  info: (msg: string) => showToastNotification(msg, 'success'),
};
